import React from 'react';
import "../../css/styles.css";
import LinkCard from '../shared-components/link_card';
import SavingsOverTimeModal from './savings_over_time_modal';
import LoanCalculatorModal from './loan_calculator_modal';
import CreditCardCalculatorModal from './credit_card_calculator_modal';


class MoneyCalculators extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
           openCalculatorSw: false,
           calculateOnly: false,
        }    
        this.calculatorType = "";
       
    }

determineCalculatorType(buttonSlctd){
    this.calculatorType = buttonSlctd;
    this.setState({openCalculatorSw: true});
}


closeCalculator(){
    this.setState({openCalculatorSw: false});
}

  render() {
        
                   
  return <>
           <div className="col-sm-8 mt-1">
           <div className="card mt-3 rounded-corners-lg h-100 ">
                <button className="pages-back-button ml-4 mt-4" 
                    onClick ={()=> this.props.goBack()}>
                                    Back
                </button>

            <h3 className="mt-0 text-center">Money Calculators</h3>
            <h6 className="mt-2, mx-5 text-left">You cannot earn extra cash or increase your salary by using these money
                calculators, but working with these will certainly help your understanding of loans, savings and
                credit cards.
            </h6>
            <div className="center-large-buttons">
                <span className="row w-100 ml-4 mx-0">
                    <div className="col-sm-5 ml-4" onClick={() => this.determineCalculatorType("Loan")}>
                        <LinkCard name="Loan Calculator" imgSrc='./assets/ExtraCredit/learningAboutLoans.png' 
                            alt=""/>
                    </div>
                    <div className="col-sm-5 ml-4" onClick={() => this.determineCalculatorType("CreditCard")}>
                        <LinkCard name="Credit Card Calculator" imgSrc='./assets/ExtraCredit/creditCard.png'
                            alt=""
                            />
                    </div>
                </span>
                <span className="row w-100 ml-4 mx-0">
                    <div className="col-sm-5 ml-4" onClick={() => this.determineCalculatorType("Savings")}>
                        <LinkCard name="Savings Calculator" imgSrc='./assets/ExtraCredit/saveMoney.png'
                            alt=""
                            />
                    </div>
                </span>
            </div>

        </div>
        
        {this.calculatorType === "Loan" ?
            <LoanCalculatorModal show={this.state.openCalculatorSw} 
                exerciseButtons={true}
                onClose={() => this.closeCalculator()} 
                loanChallenges={false}
                calculatorSw ={this.state.calculateOnly}/>
        :
            null
        }
         {this.calculatorType === "Savings" ?
            <SavingsOverTimeModal show={this.state.openCalculatorSw}
                exerciseButtons={true}
                gutters={this.gutters}
                onClose={() => this.closeCalculator()}
                calculatorSw={this.state.calculateOnly} 
                displayInitialAmt={true}/>
        :
            null
        }
        {this.calculatorType === "CreditCard"  ?
            <CreditCardCalculatorModal show={this.state.openCalculatorSw} 
                exerciseButtons={true}
                onClose={() => this.closeCalculator()} 
            />
        :
            null
        }
       
    </div>   
</>
  }
  

}

export default MoneyCalculators;